export default "__VITE_ASSET__bDrgoc0l__"